import { colors } from "@material-ui/core";
import React, { useState } from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import {
  getDefaultValuesFromConfigFields,
  getNonSensitiveSettings,
} from "../../modals/ConfigureIntegrationModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};
  const defaultValueMap = getDefaultValuesFromConfigFields(
    destination.configFields,
  );
  const nonSensitiveSettings = getNonSensitiveSettings(
    settings,
    destination.configFields,
  );
  const [values, setValues] = useState({
    ...defaultValueMap,
    ...nonSensitiveSettings,
  });

  return (
    <ConfigureDestinationsModal
      limitSettings={["appToken", "s2sSecurityToken", "environment"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
      valuesStateObjFromParent={[values, setValues]}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const isConfigured = "appToken" in settings && "s2sSecurityToken" in settings;

  return (
    <DestinationConfigRow
      name="Credentials"
      textColor={isConfigured ? "" : colors.red[600]}
      labelText={isConfigured ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const SessionEventNamesModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};
  const defaultValueMap = getDefaultValuesFromConfigFields(
    destination.configFields,
  );
  const nonSensitiveSettings = getNonSensitiveSettings(
    settings,
    destination.configFields,
  );
  const [values, setValues] = useState({
    ...defaultValueMap,
    ...nonSensitiveSettings,
  });

  return (
    <ConfigureDestinationsModal
      limitSettings={["sessionEventNames"]}
      open={open}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
      valuesStateObjFromParent={[values, setValues]}
    />
  );
};

const SessionEventNamesRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const raw = settings.sessionEventNames || [];
  const names = Array.isArray(raw) ? raw : [raw];
  const count = names.filter(Boolean).length;

  return (
    <DestinationConfigRow
      name="Session event names"
      labelText={
        count > 0
          ? names.filter(Boolean).join(", ")
          : 'Default: "Application Installed"'
      }
      onOpenConfigModal={() => setConfigModalOpen("sessionEventNames")}
    />
  );
};

const EventTokenMappingModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};
  const defaultValueMap = getDefaultValuesFromConfigFields(
    destination.configFields,
  );
  const nonSensitiveSettings = getNonSensitiveSettings(
    settings,
    destination.configFields,
  );
  const [values, setValues] = useState({
    ...defaultValueMap,
    ...nonSensitiveSettings,
  });

  return (
    <ConfigureDestinationsModal
      limitSettings={["eventTokenMapping"]}
      open={open}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
      valuesStateObjFromParent={[values, setValues]}
    />
  );
};

const EventTokenMappingRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const mappings = settings.eventTokenMapping || [];
  const count = mappings.length;

  return (
    <DestinationConfigRow
      name="Event token mapping"
      labelText={
        count > 0
          ? `${count} event${count === 1 ? "" : "s"} mapped`
          : "No events mapped"
      }
      onOpenConfigModal={() => setConfigModalOpen("eventTokenMapping")}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const SESSION_EVENT_NAMES = "SESSION_EVENT_NAMES";
const EVENT_TOKEN_MAPPING = "EVENT_TOKEN_MAPPING";

const Rows = {
  CREDENTIALS: CredentialsRow,
  SESSION_EVENT_NAMES: SessionEventNamesRow,
  EVENT_TOKEN_MAPPING: EventTokenMappingRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  SESSION_EVENT_NAMES: SessionEventNamesModal,
  EVENT_TOKEN_MAPPING: EventTokenMappingModal,
};

const RowOrder = [CREDENTIALS, SESSION_EVENT_NAMES, EVENT_TOKEN_MAPPING];

export default {
  Rows,
  RowOrder,
  Modals,
};
